<template>
    <div class="printOrderPage">
        <div class="header">
            <headerNotice routerName="批量打印发货单"></headerNotice>
            <el-row class="printBtn" :gutter="24" style="margin-top:20px;">
                <el-col :span="2">
                    <el-button type="info" @click="back">返回</el-button>
                </el-col>
                <el-col :span="3" :offset="5">
                    <el-button type="primary" id="myPreview3" @click="printSystem">系统打印</el-button>
                </el-col>
                      <el-col :span="4" :offset="5">
                    <a
                        class="printDownload"
                        href="/CLodop_Setup_for_Win32NT.exe"
                        download="CLodop_Setup_for_Win32NT.exe"
                    >下载LODOP打印插件</a>
                </el-col>
            </el-row>
        </div>
        <div class="printSetting">
            <p style="font-size:24px;margin:20px;">打印配置:</p>
            <p style="margin:10px 40px;">
                1：选择如下打印机：
                <input type="radio" id="Radio1" name="RadioS1" :checked="printMac==1" @click="choosePrint(1)">默认打印机
                <input type="radio" id="Radio2" name="RadioS1" :checked="printMac==2" @click="choosePrint(2)">指定打印机:
                <select  id="PrinterList" size="1"  v-if="printMac==2" v-model="printMacType">
                    <option v-for="(item, index) in printMacNameList" :key="index" :value="index">{{item}}</option>
                </select>
            </p>
            <p style="margin:10px 40px;">
                2：用宽
                <input type="text" size="5"  id="W4"  v-model="pageWidth">(mm)<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 高
                <input type="text" size="5"  id="H4"  v-model="pageHeight">(mm)进行
                <el-button type="primary" id="myPreview3" @click="printPre">插件预览打印</el-button>
                <el-button type="primary" id="myPreview3" @click="printNow">插件直接打印</el-button>
            </p>
        </div>
        <script id="scriptTxt" type=text/html >
            .printBox {
                display:flex;
                flex-direction:column;
                justify-content:space-around;
            }
            // 订单信息
            .orderInfo {
              width: 80%;
              margin: 20px 10% 50px 10%;
              margin-bottom: 100px;
              box-sizing: border-box;
            }
            .title {
                height: 60px;
                width: 100%;
                text-align: center;
                line-height: 60px;
                font-size: 18px;
                font-weight: 700;
                border: 1px solid #000;
                box-sizing: border-box;
            }
            .tableBox {
                width: 100%;
                text-align: center;
                border-collapse: collapse;
                border-spacing: 1px;
                border: 1px solid #000;
            }
            .tableBox  thead {
                height: 40px;
            }
            .tableBox  thead th {
                height: 40px;
            }
            .tableBox tbody tr {
                height: 40px;
                font-size: 12px;
            }
            .count {
                height: 40px;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                font-size: 14px;
                color: #666;
                border: 1px solid #000;
                border-top: none;
                border-bottom: none;
            }
            .count span {
                margin-left: 20px;
            }
            .receipt {
                border: 1px solid #000;
                border-top: none;
                padding-left: 20px;
                height: 80px;
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                font-size: 14px;
                color: #666;
            }
            .receipt span {
                display: inline-block;
                min-width: 270px;
            }
        </script> 

        <div class="printBox" id="printBox">
            <!-- 订单信息 -->
            <div
                class="orderInfo"
                v-loading="loading"
                v-for="(item, index) in orderList"
                :key="index"
                :id="'printID'+index"
            >
                <div class="goodsList">
                    <div class="title">源码发货单</div>
                    <div class="receipt">
                        <div>
                            <span>收货人：{{item.recipient}}</span>
                            <!-- <span>订单序号：{{item.orderID}}</span> -->
                        </div>
                        <div>
                            <span>订单编号：{{item.orderCode}}</span>
                            <span>手机号：{{item.phone}}</span>
                        </div>
                        <div>
                            <span>打印日期： {{item.printTime}}</span>
                            <span>收货地址：{{item.address}}</span>
                        </div>
                    </div>
                    <!-- <div class="count">
                        <span>商品总价： ¥{{item.disAmount}}</span>
                        <span v-if="item.postage>0">运费： ¥{{item.postage}}</span>
                        <span v-else>运费： 包邮</span>
                        <span v-if="item.postage>0">订单总金额：¥{{item.disAmount+item.postage}}</span>
                        <span v-else>订单总金额：¥{{item.disAmount}}</span>
                        <span>支付方式：{{item.payType==2?'余额':'微信'}}</span>
                    </div> -->
                    <table class="tableBox" border>
                        <thead>
                            <th>序号</th>
                            <th>商品编码</th>
                            <th>商品名称</th>
                            <!-- <th>价格（￥）</th> -->
                            <th>数 量</th>
                            <th>规格</th>
                            <!-- <th>小 计</th> -->
                        </thead>
                        <tbody>
                            <tr v-for="(item2, index2) in item.orderItemListing" :key="index2">
                                <td>{{index2+1}}</td>
                                <td>{{item2.propCode}}</td>
                                <td>{{item2.title}}</td>
                                <!-- <td>{{item2.price}}</td> -->
                                <td>{{item2.num}}</td>
                                <td>{{item2.propName}}</td>
                                <!-- <td>{{item2.total}}</td> -->
                            </tr>
                        </tbody>
                    </table>
                     <!-- 定制信息 -->
                    <div class="title" v-if="item.orderCustomisationList.length>0">
                    <i class="el-icon-info"></i>
                    <span>定制信息</span>
                    </div>
                    <div v-for="item in item.orderCustomisationList" v-bind:key="item">
                    <div v-if="item.customizationType==1">
                        定制类型：图案 定制图案名称：{{item.customizationName}}
                        <br />定制图案：
                        <img :src="baseUrl+item.customizationImageUrl" alt width="100" height="100" />
                    </div>
                    <div v-else>定制类型：语录 语录名称：{{item.customizationName}}</div>
                    </div>
                </div>
                
                
            </div>
        </div>
    </div>
</template>

<script>
import headerNotice from './../../components/common/headerNotice.vue'
import printJS from 'print-js'
let LODOP = getLodop();
export default {
    data() {
        return {
            loading: false,
            orderIDArr: [],
            orderList: [
                {
                    orderItemListing: []
                }
            ],
            printCount:0,
            pageWidth:1950,//纸张宽
            pageHeight:980,//纸张高
            printMac:1,//打印机状态 默认  选择
            printMacNameList:[],//打印机列表
            printMacType:0,//打印机类型
            orderCustomisationList: []
        }
    },
    components: {
        headerNotice
    },
    created(){
        if(localStorage.getItem('defaultOrderPrintProps')){
            let defaultPrintProps = JSON.parse(localStorage.getItem('defaultOrderPrintProps'));
            this.pageWidth = defaultPrintProps.pageWidth;
            this.pageHeight = defaultPrintProps.pageHeight;
            this.printMac = defaultPrintProps.printMac;
            this.printMacType = defaultPrintProps.printMacType;
        }
    },
    mounted() {
        this.orderIDArr = sessionStorage.getItem('orderIDArr');
        this.orderIDArr = this.orderIDArr.split(',')
        this.getDatas();
        if(LODOP){
            this.CreatePrinterList();
        }
    },
    methods: {
        //获取数据
        getDatas() {
            let self = this;
            self.loading = true;
            $http.POST({
                url: this.$store.state.apiUrl + "/api/services/app/AdminOrder/OrderItemList",
                data: {
                    orderIDs: this.orderIDArr
                },
                success(res) {
                    self.orderList = res;
                    self.printCount = res.length;
                    self.loading = false;
                },
                fail(res) {
                    self.loading = false;
                }
            })
        },
        //预览打印
        printPre() {
            let self = this;
            try{ 
                if (LODOP.VERSION) {
                    let  scriptTxt =  document.getElementById("scriptTxt").innerHTML;
                    let strFormHtml;
                    LODOP.PRINT_INIT("发货单");
                    for (let i = 0; i < self.printCount; i++) {
                        LODOP.NewPage();		
                        strFormHtml = '<style>'+scriptTxt+'</style>' + document.getElementById("printID"+i).innerHTML;
                        if(this.printMac==1){
                        LODOP.SET_PRINTER_INDEX(-1);
                        }else {
                            LODOP.SET_PRINTER_INDEX(this.printMacType);//选择打印机
                        }
                        LODOP.SET_PRINT_PAGESIZE(1,Number(this.pageWidth),Number(this.pageHeight),"CreateCustomPage");
                        LODOP.ADD_PRINT_HTM(0, 0, '100%', '100%', strFormHtml);//添加打印内容
                        LODOP.SET_PRINT_MODE("POS_BASEON_PAPER",true);
                    }
                    LODOP.PREVIEW();
                    let params = {
                        pageWidth:this.pageWidth,
                        pageHeight:this.pageHeight,
                        printMac:this.printMac,
                        printMacType:this.printMacType,
                    }
                    localStorage.setItem('defaultOrderPrintProps',JSON.stringify(params));
                };
            }catch(err){ 
                alert("本机未安装Lodop控件！\n 请先下载安装！"); 
                window.location.reload();
            } 
        },
        //直接打印
        printNow(){
            let self = this;
            try{ 
                if (LODOP.VERSION) {
                    let  scriptTxt =  document.getElementById("scriptTxt").innerHTML;
                    let strFormHtml;
                    LODOP.PRINT_INIT("发货单");
                    for (let i = 0; i < self.printCount; i++) {
                        // LODOP.NewPage();		
                        strFormHtml = '<style>'+scriptTxt+'</style>' + document.getElementById("printID"+i).innerHTML;
                        if(this.printMac==1){
                            LODOP.SET_PRINTER_INDEX(-1);
                        }else {
                            LODOP.SET_PRINTER_INDEX(this.printMacType);//选择打印机
                        }
                        LODOP.SET_PRINT_PAGESIZE(1,Number(this.pageWidth),Number(this.pageHeight),"CreateCustomPage");
                        LODOP.ADD_PRINT_HTM(0, 0, '100%', '100%', strFormHtml);//添加打印内容
                        LODOP.SET_PRINT_MODE("POS_BASEON_PAPER",true);
                        LODOP.PRINT();

                    }
                    let params = {
                        pageWidth:this.pageWidth,
                        pageHeight:this.pageHeight,
                        printMac:this.printMac,
                        printMacType:this.printMacType,
                    }
                    localStorage.setItem('defaultOrderPrintProps',JSON.stringify(params));
                };
            }catch(err){ 
                alert("本机未安装Lodop控件！\n 请先下载安装！"); 
                window.location.reload();
            } 
        },
        choosePrint(val){
            this.printMac = val;
        },
        //创建打印机列表
        CreatePrinterList() {
            let iPrinterCount = LODOP.GET_PRINTER_COUNT();
            this.printMacNameList=[];
            for (var i = 0; i < iPrinterCount; i++) {
                this.printMacNameList.push(LODOP.GET_PRINTER_NAME(i));
            };
        },
        //系统打印
        printSystem(){
            printJS({
                printable: 'printBox',
                type: 'html',
                // 继承原来的所有样式
                targetStyles: ['*']
            })
        },
        //返回
        back() {
            this.$router.back();
        }
    }
}


</script>

<style lang='scss'  scoped>
// <!--startprint-->
.printOrderPage {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
    .header {
        position: relative;
        .printBtn {
            position: absolute;
            top: -10px;
            right: 20%;
        }
        .printDownload {
            display: inline-block;
            line-height: 1;
            white-space: nowrap;
            cursor: pointer;
            background: #fff;
            border: 1px solid #dcdfe6;
            color: #606266;
            -webkit-appearance: none;
            text-align: center;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            outline: 0;
            margin: 0;
            -webkit-transition: .1s;
            transition: .1s;
            font-weight: 500;
            padding: 12px 20px;
            font-size: 14px;
            border-radius: 4px;
            color: #fff;
            background-color: #409EFF;
            border-color: #409EFF;
        }
    }
}

// 订单信息
.orderInfo {
    width: 80;
    margin: 20px 10% 50px 10%;
    box-sizing: border-box;
    .title {
        height: 60px;
        width: 100%;
        text-align: center;
        line-height: 60px;
        font-size: 18px;
        font-weight: 700;
        // background: #f3f3f3;
        border: 1px solid #000;
        box-sizing: border-box;
    }
    .tableBox {
        width: 100%;
        text-align: center;
        border-collapse: collapse;
        border-spacing: 1px;
        border: 1px solid #000;
        thead {
            height: 40px;
            th {
                height: 40px;
            }
        }
        tbody {
            tr {
                height: 30px;
                font-size: 12px;
            }
        }
    }
    .count {
        height: 40px;
        // background: #f9fafc;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 14px;
        color: #666;
        border: 1px solid #000;
        border-top: none;
        border-bottom: none;
        span {
            margin-left: 20px;
        }
    }
    .receipt {
        border: 1px solid #000;
        border-top: none;
        padding-left: 20px;
        height:80px;
        // background: #f9fafc;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        font-size: 14px;
        color: #666;
        span {
            display: inline-block;
            min-width: 270px;
        }
    }
}
// <!--endprint-->
</style>